import React, {PropTypes} from 'react';

const IconListItem = ({value}) => (
  <div className="list-item-icon">
    <span>{value}</span>
  </div>
);

IconListItem.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default IconListItem;
